import axios from "axios";

export const handleAxiosError = (
  error: unknown
):
  | { type: "network"; error: { status: number; data: unknown } }
  | { error: { type: "unknown" } } => {
  if (axios.isAxiosError(error)) {
    const status = error.response?.status ?? 500;
    const data = error.response?.data ?? error.message;
    return { type: "network", error: { status, data } };
  }

  return {
    error: { type: "unknown" },
  };
};
